<template>
	<v-container fluid class="d-flex form-page-gutter" style="gap: 5px">
		<v-card class="rounded-xl" elevation="0" min-width="40%">
			<v-card-title>
				<v-container class="d-flex justify-space-between pa-0 mb-2">
					<div class="text-h5 font-weight-semibold">Payment</div>
					<v-btn
						depressed
						rounded
						color="primary"
						@click="submitPayments()"
						:loading="isPaymentLoading"
						:disabled="!formValid">
						<v-icon class="mr-2">mdi-cash</v-icon>
						Submit Payment
					</v-btn>
				</v-container>
				<v-container class="d-flex justify-end align-center pa-0">
					<!-- <v-switch
						v-model="autoSelect"
						label="Auto Select"
						class="mt-0 mr-4"
						hide-details
						color="primary"
						dense
						@change="resetAmountReceived"></v-switch> -->
					<v-btn
						depressed
						rounded
						color="primary"
						@click="resetAmountReceived">
						<v-icon class="mr-2">mdi-undo</v-icon>
						Reset Amount Received
					</v-btn>
				</v-container>
			</v-card-title>
			<v-card-text class="d-flex justify-space-between">
				<div class="red--text">
					<span>Selected Amount:</span>
					<span class="mr-1">
						{{ getCurrencySymbol(currencyId) }}
					</span>
					<span>
						{{
							convertToCleanNumber(
								selectedAmount,
								getCurrencySymbol(currencyId) == "$"
							)
						}}
					</span>
				</div>
				<div>
					<div class="grey--text text--darken-2">
						<span>Amount Received:</span>
						<span class="mr-1">
							{{ getCurrencySymbol(currencyId) }}
						</span>
						<span>{{ convertToCleanNumber(amountReceived) }}</span>
					</div>
					<div class="grey--text text--darken-2">
						<span>Amount To Be Credited:</span>
						<span class="mr-1">
							{{ getCurrencySymbol(currencyId) }}
						</span>
						<span>{{ convertToCleanNumber(toBeCredit) }}</span>
					</div>
				</div>
			</v-card-text>
			<v-card-text>
				<div class="primary--text d-flex justify-space-between">
					<div>Credit in Dong:</div>
					<div>
						<span>{{ convertToCleanNumber(dongCredit) }}</span>
					</div>
				</div>
				<div class="primary--text d-flex justify-space-between">
					<div>Credit in Dollar:</div>
					<div>
						<span>{{ convertToCleanNumber(dollarCredit) }}</span>
					</div>
				</div>
			</v-card-text>
			<v-card-text>
				<v-form ref="form" v-model="formValid">
					<v-autocomplete
						class="mb-2"
						:rules="[(v) => !!v || 'Required']"
						dense
						rounded
						outlined
						hide-details
						item-value="id"
						:item-text="getCustomerName"
						:items="customers"
						label="Customer"
						v-model="customerId"
						@change="
							handleAmountReceived();
							getCustomer();
						"></v-autocomplete>
					<v-autocomplete
						class="mb-2"
						:rules="[(v) => !!v || 'Required']"
						dense
						rounded
						outlined
						hide-details
						item-text="displayName"
						item-value="id"
						:items="currencyTypes"
						label="Currency"
						v-model="currencyId"
						@change="handleAmountReceived"></v-autocomplete>
					<v-autocomplete
						class="mb-2"
						dense
						rounded
						outlined
						hide-details
						item-text="text"
						item-value="value"
						:items="yesNo"
						label="Use Credit"
						v-model="useCredit"
						@change="handleAmountReceived"></v-autocomplete>
					<v-text-field
						v-if="autoSelect"
						class="mb-2"
						:rules="[
							(v) =>
								v > 0 ||
								'Amount Received must be greater than 0',
							(v) => !!v || 'Required',
						]"
						dense
						outlined
						rounded
						hide-details
						:prefix="getCurrencySymbol(currencyId)"
						label="Amount Received"
						v-model.number="amountReceived"
						@change="handleAmountReceived"></v-text-field>
					<div class="mb-2">
						<date-picker
							:rules="[(v) => !!v || 'Required']"
							label="Payment Date"
							v-model="paymentDate"
							required></date-picker>
					</div>

					<v-autocomplete
						:rules="[(v) => !!v || 'Required']"
						dense
						rounded
						outlined
						hide-details
						label="Payment Type"
						item-value="id"
						item-text="displayName"
						:items="paymentTypes"
						v-model="paymentMethodId"
						required></v-autocomplete>
				</v-form>
			</v-card-text>
		</v-card>
		<v-card class="rounded-xl" elevation="0" min-width="60%">
			<v-card-text>
				<invoice-list
					v-model="filteredInvoices"
					:custom-headers="[
						'_selected',
						'id',
						'mtlTracking',
						'customerId',
						'totalAmount',
						'_amountDue',
						'paymentStatusId',
						'dateCreated',
						'_amountReceived',
					]"
					:loading="isPaymentLoading"
					@calculate-amount-received="calculateAmountReceived"
					@distribute-amount-received="
						distributeAmountReceived
					"></invoice-list>
			</v-card-text>
		</v-card>
	</v-container>
</template>
<script>
import DatePicker from "@/components/DatePicker.vue";
import generalMixin from "@/js/general-mixin";
import InvoiceList from "@/components/InvoiceList.vue";
import backendService from "@/services/backend-service";
import { CurrencyType, PaymentStatus } from "@/js/enum";
import Decimal from "decimal.js";
export default {
	name: "PaymentPage",
	mixins: [generalMixin],
	components: { "date-picker": DatePicker, "invoice-list": InvoiceList },
	data() {
		return {
			autoSelect: true,
			toBeCredit: 0,
			useCredit: false,
			amountReceived: null,
			currencyId: null,
			customerId: null,
			customer: {},
			paymentDate: null,
			paymentMethodId: null,
			description: "",
			isPaymentLoading: false,
			formValid: false,
			headers: [
				{
					text: "Id",
					align: "start",
					value: "id",
				},
				{
					text: "Tracking #",
					align: "start",
					value: "mtlTracking",
				},
				{ text: "Customer", value: "customerId" },
				{
					text: "Total Amount",
					value: "totalAmount",
				},
				{ text: "Payment", value: "paymentStatusId" },
				{ text: "Date Created", value: "dateCreated" },
			],
			selected: [],
		};
	},
	mounted: function () {
		if (this.$route.params.customerId) {
			this.customerId = parseInt(this.$route.params.customerId);
			this.getCustomer();
		}
		this.currencyId = this.getIdByEnum(CurrencyType.UsDollar);
		this.$store.dispatch("getInvoices");
	},
	computed: {
		Dong() {
			return this.getIdByEnum(CurrencyType.VietDong);
		},
		Dollar() {
			return this.getIdByEnum(CurrencyType.UsDollar);
		},
		Pending() {
			return this.getIdByEnum(PaymentStatus.Pending);
		},
		Paid() {
			return this.getIdByEnum(PaymentStatus.Paid);
		},
		PartiallyPaid() {
			return this.getIdByEnum(PaymentStatus.PartiallyPaid);
		},
		currencyTypes() {
			if (this.dropdownToOptions["currency"]) {
				return this.dropdownToOptions["currency"].options;
			}
			return [];
		},
		dongCredit() {
			if (this.customer && this.customer.dongCredit)
				return this.customer.dongCredit;
			return 0;
		},
		dollarCredit() {
			if (this.customer && this.customer.dollarCredit)
				return this.customer.dollarCredit;
			return 0;
		},
		dropdownToOptions() {
			return this.$store.getters["dropdownToOptions"];
		},
		invoices() {
			return this.$store.getters["invoices"];
		},
		filteredInvoices() {
			if (this.invoices.length == 0) return [];
			if (!this.customerId) return this.invoices;
			return this.invoices.filter(
				(e) =>
					e.customerId == this.customerId ||
					e.parentCustomerId == this.customerId
			);
		},
		paymentTypes() {
			if (this.dropdownToOptions["paymentType"]) {
				return this.dropdownToOptions["paymentType"].options;
			}
			return [];
		},
		selectedAmount() {
			let selectedAmount = new Decimal(0);
			let invoices = this.filteredInvoices;
			for (let i = 0; i < invoices.length; i++) {
				let invoice = invoices[i];
				if (
					invoice._selected &&
					this.currencyId == invoice.currencyId
				) {
					selectedAmount = selectedAmount.plus(
						this.decimal(invoice._amountDue)
					);
				}
			}
			return selectedAmount;
		},
	},
	methods: {
		decimal(value) {
			return new Decimal(value || 0);
		},
		decimalToNumber(value) {
			return this.decimal(value).toNumber();
		},
		calculateAmountReceived() {
			let sum = new Decimal(0);
			for (let i = 0; i < this.invoices.length; i++) {
				let invoice = this.invoices[i];
				if (invoice._selected && invoice._amountReceived) {
					sum = sum.plus(new Decimal(invoice._amountReceived));
				}
			}
			this.amountReceived = this.decimalToNumber(sum);
		},
		getCustomerName(item) {
			return `${item.id} - ${item.name} - ${item.phone}`;
		},
		getCustomer() {
			backendService.getCustomerById(this.customerId).then((response) => {
				this.customer = response.data;
			});
		},
		handleAmountReceived() {
			// If auto-select is disabled, don't automatically select invoices
			if (!this.autoSelect) {
				return;
			}

			let invoices = this.filteredInvoices;
			this.toBeCredit = 0;
			if (this.useCredit) {
				if (
					this.Dong == this.currencyId &&
					this.decimal(this.amountReceived).greaterThan(
						this.dongCredit
					)
				) {
					this.amountReceived = this.dongCredit;
				}
				if (
					this.Dollar == this.currencyId &&
					this.decimal(this.amountReceived).greaterThan(
						this.dollarCredit
					)
				) {
					this.amountReceived = this.dollarCredit;
				}
			}
			let leftover = this.decimal(this.amountReceived);

			let possibleIdx = -1;
			if (!this.customerId) return;
			let isDirty = false;
			// if (this.selectedAmount > 0) {
			//   isDirty = true;
			// }

			for (let i = invoices.length - 1; i >= 0; i--) {
				let invoice = invoices[i];
				invoice._amountReceived = null;
				if (!isDirty) invoice._selected = false;
				if (leftover.lessThanOrEqualTo(0)) continue;
				let amountDue = this.decimal(invoice._amountDue);
				if (
					isDirty &&
					invoice._selected &&
					this.currencyId == invoice.currencyId &&
					invoice.paymentStatusId != this.Paid
				) {
					if (amountDue.lessThanOrEqualTo(leftover)) {
						invoice._amountReceived = this.decimalToNumber(
							invoice.totalAmount
						);
						leftover = leftover.minus(amountDue);
					} else {
						invoice._amountReceived =
							this.decimalToNumber(leftover);
						leftover = new Decimal(0);
					}
				} else if (
					!isDirty &&
					this.currencyId == invoice.currencyId &&
					invoice.paymentStatusId != this.Paid
				) {
					if (amountDue.lessThanOrEqualTo(leftover)) {
						invoice._amountReceived =
							this.decimalToNumber(amountDue);
						leftover = leftover.minus(amountDue);
						invoice._selected = true;
					} else {
						invoice._amountReceived =
							this.decimalToNumber(leftover);
						invoice._selected = true;
						leftover = new Decimal(0);
					}
				}
			}
			if (leftover.greaterThan(0)) {
				if (possibleIdx >= 0) {
					invoices[possibleIdx]._selected = true;
					invoices[possibleIdx]._amountReceived =
						this.decimalToNumber(leftover);
				} else {
					if (!this.useCredit)
						this.toBeCredit = this.decimalToNumber(leftover);
				}
			}

			this.$forceUpdate();
		},
		distributeAmountReceived() {
			let invoices = this.filteredInvoices;
			let leftover = this.decimal(this.amountReceived);
			this.toBeCredit = 0;
			if (!this.customerId) return;
			for (let i = invoices.length - 1; i >= 0; i--) {
				let invoice = invoices[i];
				if (
					invoice._selected &&
					this.currencyId == invoice.currencyId &&
					invoice.paymentStatusId != this.Paid
				) {
					let amountDue = this.decimal(invoice._amountDue);
					if (amountDue.lessThanOrEqualTo(leftover)) {
						invoice._amountReceived =
							this.decimalToNumber(amountDue);
						leftover = leftover.minus(amountDue);
					} else if (leftover.greaterThan(0)) {
						invoice._amountReceived =
							this.decimalToNumber(leftover);
						leftover = new Decimal(0);
					} else {
						invoice._amountReceived = null;
					}
				}
			}
			if (leftover.greaterThan(0)) {
				if (!this.useCredit)
					this.toBeCredit = this.decimalToNumber(leftover);
			} else {
				this.toBeCredit = 0;
			}
			this.$forceUpdate();
		},
		submitPayments() {
			let payments = [];
			this.isPaymentLoading = true;
			if (!this.$refs.form.validate()) {
				return;
			}
			for (let i = 0; i < this.invoices.length; i++) {
				let invoice = this.invoices[i];
				let payment = {};
				if (
					invoice._selected &&
					this.decimal(invoice._amountReceived).greaterThan(0)
				) {
					payment.accountId = this.customerId;
					payment.currencyId = this.currencyId;
					payment.typeId = this.paymentMethodId;
					payment.invoiceId = invoice.id;
					if (this.useCredit) {
						payment.credit = this.decimalToNumber(
							invoice._amountReceived
						);
						payment.amount = 0;
					} else {
						payment.credit = 0;
						payment.amount = this.decimalToNumber(
							invoice._amountReceived
						);
					}
					payment.tender = 0;
					payment.cashChange = 0;
					payment.paymentDate = this.paymentDate;
					payments.push(payment);
				}
			}
			if (this.decimal(this.toBeCredit).greaterThan(0)) {
				let payment = {};
				payment.accountId = this.customerId;
				payment.currencyId = this.currencyId;
				payment.typeId = this.paymentMethodId;
				if (this.useCredit) {
					payment.credit = this.decimalToNumber(this.toBeCredit);
					payment.amount = 0;
				} else {
					payment.credit = 0;
					payment.amount = this.decimalToNumber(this.toBeCredit);
				}

				payment.tender = 0;
				payment.cashChange = 0;
				payment.paymentDate = this.paymentDate;
				payments.push(payment);
			}
			if (payments.length > 0) {
				backendService
					.submitPayments(payments)
					.then(() => {
						this.timer(1000).then(() => {
							this.invoices.forEach((e) => {
								if (e._selected) {
									if (
										this.useCredit &&
										this.currencyId == this.Dong
									) {
										this.customer.dongCredit =
											this.decimalToNumber(
												this.decimal(
													this.customer.dongCredit
												).minus(e._amountReceived)
											);
									}
									if (
										this.useCredit &&
										this.currencyId == this.Dollar
									) {
										this.customer.dollarCredit =
											this.decimalToNumber(
												this.decimal(
													this.customer.dollarCredit
												).minus(e._amountReceived)
											);
									}
									let amountReceived = this.decimal(
										e._amountReceived
									);
									let amountDue = this.decimal(e._amountDue);
									if (
										amountReceived.greaterThanOrEqualTo(
											amountDue
										)
									) {
										e.paymentStatusId = this.Paid;
										e._amountDue = 0;
										e._amountReceived = null;
									} else if (e._amountReceived) {
										e.paymentStatusId = this.PartiallyPaid;
										e._amountDue = this.decimalToNumber(
											amountDue.minus(amountReceived)
										);
										e._amountReceived = null;
									}
									e._selected = false;
								}
							});
							if (
								this.decimal(this.toBeCredit).greaterThan(0) &&
								this.currencyId == this.Dong
							) {
								this.customer.dongCredit =
									this.decimalToNumber(
										this.decimal(
											this.customer.dongCredit
										).plus(this.toBeCredit)
									);
							}
							if (
								this.decimal(this.toBeCredit).greaterThan(0) &&
								this.currencyId == this.Dollar
							) {
								this.customer.dollarCredit =
									this.decimalToNumber(
										this.decimal(
											this.customer.dollarCredit
										).plus(this.toBeCredit)
									);
							}

							this.isPaymentLoading = false;
							this.toBeCredit = 0;
							this.paymentDate = null;
							this.paymentMethodId = null;
							this.amountReceived = null;
							this.$refs.form.resetValidation();

							this.successSnackbar(
								"Successfully submitted new payment(s)"
							);
						});
					})
					.catch(() => {
						this.timer(1000).then(() => {
							this.isPaymentLoading = false;
							this.errorSnackbar("Ops! something is not right");
						});
					});
			} else {
				this.timer(1000).then(() => {
					this.isPaymentLoading = false;
					this.errorSnackbar("No invoices have been paid");
				});
			}
		},
		resetAmountReceived() {
			this.invoices.forEach((e) => {
				this.$set(e, "_selected", false);
				this.$set(e, "_amountReceived", null);
			});
			this.amountReceived = null;
			this.handleAmountReceived();
		},
	},
	watch: {
		"$route.params.customerId": function (newVal, oldVal) {
			this.customerId = newVal;
			oldVal;
			this.getCustomer();
		},
	},
};
</script>
